import { deviceType } from '@/utils/common'
import PcPersonalProfile from './pc/profile/index.vue'
import MobilePersonalProfile from './mobile/profile/index.vue'

const basePath = '/recruiting/personal'

export default {
  path: `${basePath}/profile`,
  component: deviceType.isPc ? PcPersonalProfile : MobilePersonalProfile,
  meta: {
    isAllInclude: true,
    titleI18nKey: 'personal.menu.myProfile',
    mobileFlexible: true,
    mobileHomeMenu: {
      iconClass: 'iconresume',
      nameI18nKey: 'personal.resume.homeMenu.name',
      descI18nKey: 'personal.resume.homeMenu.desc'
    },
    employeePermission: ['COMPUTED_EMPLOYEE_CAN_APPLY_JOB']
  }
}
